"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const colors_1 = __importDefault(require("../colors"));
const appBar = {
    MuiAppBar: {
        styleOverrides: {
            root: {
                boxShadow: "none",
                borderBottom: `1px solid ${colors_1.default.secondary[600]}`,
                borderRadius: 0,
            },
        },
    },
};
exports.default = appBar;
